import React from 'react';

import { faUpload } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import DromoImports from 'components/dromo/imports';
import EmptyState from 'shared/empty_state';
import LoadingSpinner from 'components/loading_spinner';
import Modal from 'components/modal';

import type { Import } from 'components/dromo/types';

interface Props {
  importButton?: React.ReactNode;
  imports?: Import[];
  showDescription?: boolean;
  onClick?: () => void;
}

// TODO: Move polling into this component - external components shouldn't have to manage it
export default function Imports({ importButton, imports, showDescription, onClick }: Props) {
  const button = importButton || (
    <Button.Primary
      icon={faUpload}
      label="Import"
      onClick={onClick}
    />
  );
  let body;
  if (!imports) {
    body = <LoadingSpinner />;
  } else if (!imports.length) {
    body = (
      <EmptyState
        bodyText='Get started by clicking on the "Import" button'
        header="No Imports to Display"
        style={{ height: '400px' }}
      >
        {button}
      </EmptyState>
    );
  } else {
    body = <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="m-0"><b>Imports</b></h3>
        {button}
      </div>
      <DromoImports imports={imports} showDescription={showDescription} />
    </>;
  }

  return (
    <Modal.Body>
      {body}
    </Modal.Body>
  );
}